'use client';

import { useUnit } from 'effector-react';
// eslint-disable-next-line
import { uploadBucketAttachment } from '@nx-frontend/shared/api/bucket';
import { generalEnv } from '@nx-frontend/shared/env';
import { ImageType } from '@nx-frontend/shared/types/image-selector';
import { generateImage, getBoxFileUrl, getCropedFile } from '@nx-frontend/shared/utils';
import { $imageSelector, $imageSelectorActiveTab, $imageSelectorUploadSettings } from './store/image-selector';

export const useGetImage = () => {
  const [imageSelector, imageSelectorActiveTab, imageSelectorUploadSettings] = useUnit([
    $imageSelector,
    $imageSelectorActiveTab,
    $imageSelectorUploadSettings,
  ]);

  return async () => {
    let imageUrl: string | null = '';
    let newImage: string | null = '';
    if (imageSelectorActiveTab === ImageType.EMOJI) {
      imageUrl = imageSelector.previewEmoji;
    } else if (imageSelectorActiveTab === ImageType.ICON) {
      imageUrl = imageSelector.previewIcon;
    } else if (imageSelectorActiveTab === ImageType.URL && imageSelector && !imageSelector.previewImageError) {
      const file = await getCropedFile({
        image: imageSelector.cropImage,
        crop: imageSelector.completedCrop,
        cropSize: imageSelector.cropSize,
      }).then();
      if (!file) {
        return null;
      }
      const response = await uploadBucketAttachment({
        gatewayUrl: generalEnv.gatewayUrl,
        ...imageSelectorUploadSettings,
        file,
      });
      if (!response.attachment.storedFileUUID) {
        return null;
      }
      imageUrl = getBoxFileUrl(response.attachment.storedFileUUID);
    }

    if (imageUrl) {
      newImage = generateImage({
        type: imageSelectorActiveTab,
        value: imageUrl,
      });
    }

    return newImage;
  };
};
